import { Input, Label } from "@twilio-paste/core";

import { Field } from "../../store/definitions";

type TextFieldProps = {
    field: Field;
    onChange?: (newValue: string) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLElement>) => void;
    value?: string;
};

export const TextField = ({ field, onChange, onKeyPress, value }: TextFieldProps) => {
    const { name, label, placeholder, required } = field;

    return (
        <>
            <Label htmlFor={name}>{label}</Label>
            <Input
                type="text"
                placeholder={placeholder}
                name={name}
                id={name}
                value={value ?? ""}
                onChange={(e) => onChange?.(e.target.value)}
                required={required}
                onKeyPress={(e) => onKeyPress?.(e)}
            />
        </>
    );
};
